import { flushSync } from 'react-dom'

/**
 * A ResizeObserver for sizes that change what renders. React would render a
 * plain state update from an observer a frame late, a visible jitter; this
 * renders it before the browser paints, so the whole change lands in one frame.
 */
export function createLayoutResizeObserver(callback: ResizeObserverCallback): ResizeObserver {
  return new ResizeObserver((entries, observer) => {
    flushSync(() => callback(entries, observer))
  })
}
